




































import { Component, Ref, Vue as VueDecorator } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import User from "@/data/models/User";
import { getUserDisplayNameAndRole } from "@/utils/UserUtils";
import SearchFieldComponent from "@/components/common/SearchField.vue";

/** Show the search field only once the list is long enough to warrant it. */
const SEARCH_THRESHOLD = 8;

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "search-field": SearchFieldComponent,
  },
})
export default class UserPickerDialog extends VueDecorator {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  isShowing = false;

  resolve?: (value: User) => void = undefined;
  reject?: (reason: string) => void = undefined;

  users: User[] = [];

  searchQuery = "";

  get showSearch() {
    return this.users.length > SEARCH_THRESHOLD;
  }

  get filteredUsers() {
    const query = this.searchQuery.toLowerCase().trim();

    if (query === "") {
      return this.users;
    }

    return this.users.filter(
      (user) => this.getUserName(user).toLowerCase().indexOf(query) >= 0
    );
  }

  /**
   * Empty-state text. Distinguishes "there is nobody to pick from" from
   * "the search query filtered everyone out", so the user knows whether
   * clearing the search would help.
   */
  get emptyStateMessage() {
    return this.users.length === 0
      ? this.$t("userPicker.noUsers").toString()
      : this.$t("userPicker.noMatchingUsers").toString();
  }

  onSearchQueryChanged(searchQuery: string) {
    this.searchQuery = searchQuery;
  }

  onCancel() {
    this.isShowing = false;
  }

  getUserName(user: User | null) {
    return getUserDisplayNameAndRole(user, this);
  }

  async show(usersToSelectFrom: User[]) {
    this.users = usersToSelectFrom;
    this.searchQuery = "";
    this.isShowing = true;

    return new Promise<User>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onUserSelected(item: User) {
    this.isShowing = false;
    this.resolve && this.resolve(item);
  }
}
